export const isImageExtension = (extension: string) => {
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension.toLowerCase())
}

export const getFilenameExtension = (filename: string) => {
  return filename?.split('.').pop() || ''
}
